/**
 * The base-imagery switch: monochrome DARK vs satellite SAT.
 *
 * A segmented pill floated over the map's bottom-left corner, above the scale
 * bar. Dark is the resting aesthetic; SAT is for correlating the COP against
 * real terrain. The two segments drive mapStore.basemap, which the map
 * controller reads to toggle the raster layers — this component owns no map
 * state of its own, so it renders identically over any of the map screens.
 */

import { cn } from '@/lib/utils';
import { useMapStore, type Basemap } from '@/stores/mapStore';

const OPTIONS: { value: Basemap; label: string }[] = [
  { value: 'dark', label: 'DARK' },
  { value: 'satellite', label: 'SAT' },
];

export function BasemapToggle() {
  const basemap = useMapStore((state) => state.basemap);
  const setBasemap = useMapStore((state) => state.setBasemap);

  return (
    <div
      // data-map-panel: it floats over the map's bottom strip, so the selection
      // camera measures it and keeps a selected aircraft from under it.
      data-map-panel="basemap"
      className="glass pointer-events-auto absolute bottom-[26px] left-[16px] z-10 flex rounded-[99px] p-1"
    >
      {OPTIONS.map(({ value, label }) => (
        <button
          key={value}
          type="button"
          aria-label={`${label} basemap`}
          aria-pressed={basemap === value}
          onClick={() => setBasemap(value)}
          className={cn(
            'rounded-[99px] px-2.5 py-1 label-mono text-[9px] transition-colors',
            basemap === value
              ? 'bg-[oklch(1_0_0/0.92)] text-[#0c0c0d]'
              : 'text-[color:var(--muted-foreground-3)]',
          )}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default BasemapToggle;
